module.exports = __webpack_public_path__ + "img/fin-strategie.e5dbbeb5.svg";